import { BaseApiService } from '@/services/base-service';
import {
  ApiPagination, BaseResponse, Filters, FiltersPagination, Response,
} from '@/types';
import { Widgets, WidgetFilters } from '../types';

interface WidgetsList extends BaseResponse {
  data: {
    items: Widgets.Widget;
  };
}

export class WidgetsService extends BaseApiService {
  private readonly base_path = 'main/statistics';

  async get_widgets(): Promise<WidgetsList> {
    const { data } = await this.http_client.get<WidgetsList>(this.base_path, {

    });

    return data;
  }

  async get_filtered_widget(filters: Filters, section: string): Promise<WidgetsList> {
    const url = `${this.base_path}/${section}`;
    const payload = filters;

    const { data } = await this.http_client.get<WidgetsList>(url, {
      params: {
        filters: payload.filters,
      },
    });

    return data;
  }
}

export const default_filters = (): WidgetFilters => ({
  year: null,
  status: null,
});

export const default_certs = (): Widgets.Certs => ({
  is_cert: false,
  items: [],
});
